<app-card-layout-content class="closing-account-page">
  <app-card-layout-content-header [noLogo]="true">
    <app-card-layout-content-image>
      <app-feedback-failure-svg-icon></app-feedback-failure-svg-icon>
    </app-card-layout-content-image>
    <app-card-layout-content-title>
      <h1 i18n>Account in chiusura</h1>
    </app-card-layout-content-title>
    <app-card-layout-content-description>
      <div class="p-d-flex p-flex-column p-text-center p-mb-5">
        <span class="p-mb-4" i18n>Procedimento di chiusura account in corso.</span>
        <span id="brandLabel" class="sr-only">{{ label }} {{ brandName }}</span>
        <span aria-labelledby="brandLabel" aria-hidden="true">
          {{ label }}
          <strong>{{ brandName }}</strong
          >.
        </span>
      </div>
    </app-card-layout-content-description>
  </app-card-layout-content-header>
  <div class="p-mt-auto">
    <div class="p-d-flex p-flex-column p-ai-center p-mb-3">
      <span i18n>Hai bisogno di aiuto?</span>
      <a class="p-mt-1 p-text-bold" [href]="'tel:' + helplineNumber" i18n>Contatta l’assistenza</a>
    </div>
    <button
      class="closing-account-page__login-button"
      pButton
      label="Torna al login"
      i18n-label="ClosingAccount|Label button torna al login"
      (click)="onBackToLoginPageButton()"
    ></button>
  </div>
</app-card-layout-content>
